import { Radio, RadioGroup, Stack } from "@chakra-ui/react"
import { Colors } from "../../../theme/colors"

export type ResultsViewMode = "all" | "best"

export const DEFAULT_RESULTS_VIEW_MODE: ResultsViewMode = "all"

interface ResultsViewModeRadioProps {
  value: ResultsViewMode
  onChange: (value: ResultsViewMode) => void
}

const checkedStyles = {
  bg: Colors.Primary.c1,
  borderColor: Colors.Primary.c1
}

export const ResultsViewModeRadio = ({ value, onChange }: ResultsViewModeRadioProps): JSX.Element => (
  <RadioGroup
    value={value}
    onChange={val => {
      onChange(val as ResultsViewMode)
    }}
    size="sm"
  >
    <Stack direction={["column", "column", "row"]} spacing={["1", "1", "4"]} fontSize="13px">
      <Radio value="all" _checked={checkedStyles}>
        View all matching systems
      </Radio>
      <Radio value="best" _checked={checkedStyles}>
        View best match systems
      </Radio>
    </Stack>
  </RadioGroup>
)
